import * as analytics from '../../services/analytics.js';
import * as basketApi from '../../services/basket-api.js';
import * as voucherApi from '../../services/voucher-api.js';

export default () => ({
    errors: [],
    eventSessionId: null,
    isReady: true,
    relativeEventDate: '',
    showOptions: false,
    voucher: {
        hasOptions: false,
        id: null,
        isAvailableToPurchase: false,
        quantityAvailable: 0,
    },
    voucherOption: 0,

    init() {
        this.voucher = {
            hasOptions: this.$root.dataset.voucherOptions === '1' || this.$root.dataset.voucherOptions === 'true',
            id: parseInt(this.$root.dataset.voucherId),
            isAvailableToPurchase: this.$root.dataset.voucherAvailable === '1' || this.$root.dataset.voucherAvailable === 'true',
            quantityAvailable: parseInt(this.$root.dataset.voucherQuantity) || 0,
        };

        // The date the page shows, so the add takes it rather than whichever date is next by then.
        this.eventSessionId = parseInt(this.$root.dataset.voucherEventSession) || null;

        if (this.$root.dataset.eventDate) {
            const eventDate = new Date(this.$root.dataset.eventDate);
            const now = new Date();
            const diffMs = eventDate.getTime() - now.getTime();
            const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

            if (diffDays > 0) {
                this.relativeEventDate = `in ${diffDays} day${diffDays !== 1 ? 's' : ''}`;
            } else if (diffDays === 0) {
                this.relativeEventDate = 'today';
            } else {
                this.relativeEventDate = `${Math.abs(diffDays)} day${Math.abs(diffDays) !== 1 ? 's' : ''} ago`;
            }
        }
    },

    canAddToBasket(basketType = 'storefront') {
        if (!this.voucher) return false;

        if (!this.voucher.isAvailableToPurchase) return false;

        if (basketType === 'storefront') {
            return true
        }

        return !(this.voucher.hasOptions && this.voucherOption === 0);
    },

    async addToBasket(voucherId, optionId) {
        if (typeof optionId === 'undefined') {
            optionId = this.voucherOption;
        }

        if (this.voucher.hasOptions && optionId === 0) {
            this.showOptions = true;
            return;
        }

        this.errors = [];
        this.isReady = false;

        const result = await basketApi.add(voucherId, optionId, 1, this.eventSessionId);

        this.isReady = true;

        if (result.ok) {
            await this.refreshVoucher();
            this.hideOptions();
            this.$store.basket.show();
            analytics.sendEvent('button', 'click', 'add to order');
            analytics.sendEcommerceEvent('add_to_cart', this.$store.basket);
        } else {
            this.errors = result.data.errors || [];
        }
    },

    async refreshVoucher() {
        const data = await voucherApi.get(this.voucher.id);

        this.voucher = {
            ...this.voucher,
            ...data,
        };
    },

    hideOptions() {
        this.showOptions = false;
    },
});
